(function () {
	function init() {
		var header = document.getElementById('header');
		if (!header) {
			return;
		}

		function updateHeaderState() {
			if (window.scrollY > 0) {
				header.classList.add('active');
			} else {
				header.classList.remove('active');
			}
		}

		window.addEventListener('scroll', updateHeaderState, { passive: true });
		updateHeaderState();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
